import '~/js/modules/stickyNav';

import ResortsSchedule from '~/js/components/resorts-schedule/ResortsSchedule';
import PrivateTrainings from '~/js/components/private-trainings/PrivateTrainings';

// Variable Declaration
const schedule = document.getElementById('resorts-schedule');
const trainings = document.getElementById('private-trainings');

// Render react component
ReactDOM.render(<ResortsSchedule />, schedule);
ReactDOM.render(<PrivateTrainings />, trainings);
